module.exports = __webpack_public_path__ + "img/qrcode_course_offline.b65a53be.jpg";